import makeApi from "../../libs/axios/api";
import { type QuickOrderPayload } from "../../types/quickOrder";
const apiPromise = makeApi();

const ADD_PATH = "/order";

const submitQuickOrder = async (order: QuickOrderPayload): Promise<any> => {
  const api = await apiPromise;
  const formData = new FormData();

  Object.entries(order).forEach(([key, value]) => {
    

    if (typeof value === "object" && key !== "OrderAttachments") {
      Object.entries(value).forEach(([subKey, subValue]) => {
        formData.append(`${key}.${subKey}`, String(subValue));
      });
    } else if (key === "OrderAttachments" && Array.isArray(value)) {
      value.forEach((attachment, index) => {
        if (attachment) {
          Object.entries(attachment).forEach(
            ([attachmentKey, attachmentValue]) => {
              formData.append(
                `${key}[${index}].${attachmentKey}`,
                attachmentValue instanceof File
                  ? attachmentValue
                  : String(attachmentValue)
              );
            }
          );
        }
      });
    } else {
      
      if(key==="IsOvernightDelivery")
      {
        formData.append(key, String(value == "USOvernightDelivery" ? "true" : "false"));
      }else if(key==="ShipViaPost")
      {
        formData.append(key, String(value == "CAPostalDelivery" ? "true" : "false" ));
      }
      else{
        formData.append(key, String(value));
      }
    }
  });

  return api.post(ADD_PATH, formData).then((response) => {
    return response.data;
  });
};

const fetchQuickOrderApi = async (orderId: number): Promise<any> => {
  const api = await apiPromise;
  return api.get(`${ADD_PATH}/${orderId}`).then((response) => {
    return response.data;
  });
};

const updateQuickOrderApi = async (
  orderId: number,
  data: QuickOrderPayload
): Promise<any> => {
  const api = await apiPromise;
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (typeof value === "object" && key !== "OrderAttachments") {
      Object.entries(value).forEach(([subKey, subValue]) => {
        formData.append(`${key}.${subKey}`, String(subValue));
      });
    } else if (key === "OrderAttachments" && Array.isArray(value)) {
      value.forEach((attachment, index) => {
        if (attachment) {
          Object.entries(attachment).forEach(
            ([attachmentKey, attachmentValue]) => {
              formData.append(
                `${key}[${index}].${attachmentKey}`,
                attachmentValue instanceof File
                  ? attachmentValue
                  : String(attachmentValue)
              );
            }
          );
        }
      });
    } else {
      
      if(key==="IsOvernightDelivery")
      {
        formData.append(key, String(value == "USOvernightDelivery" ? "true" : "false"));
      }else if(key==="ShipViaPost")
      {
        formData.append(key, String(value == "CAPostalDelivery" ? "true" : "false" ));
      }
      else{
        formData.append(key, String(value));
      }
    }
  });
  return api.put(`${ADD_PATH}/${orderId}`, formData).then((response) => {
    return response.data;
  });
};

const fetchImageAnalyseApi = async (image: any): Promise<any> => {
  const api = await apiPromise;
  return api.post("/analyze", { base64Image: image }).then((response) => {
    return response.data;
  });
};

export {
  submitQuickOrder,
  fetchQuickOrderApi,
  updateQuickOrderApi,
  fetchImageAnalyseApi,
};
